// @flow strict

/**
 * @fileoverview Browser related utilities
 */

/**
 * Remove trailing slash from a string
 * @param {string} url - String to remove trailing slash from
 * @return {string} - Passed in string, with trailing slash removed
 */
export const removeTrailingSlash = (url: string): string =>
  url.charAt(url.length - 1) === '/' ? url.slice(0, url.length - 1) : url

/**
 * Programatically load script
 * @param {string} url - The url of the script to load
 * @param {object} [attributes] - Attributes to add to the element
 * @param {object} [events] - Events to listen for
 * @return {HTMLScriptElement} - Created and appended script
 */
export const loadScript = (
  url: string,
  attributes?: { [string]: string | boolean } = {},
  events?: { [string]: [Function, Object] | Function } = {}
): HTMLScriptElement => {
  // Create Element
  const script = document.createElement('script')

  // Set source
  script.src = url

  // Apply attributes
  Object.keys(attributes).forEach(key => {
    // $FlowFixMe - All possible attributes not yet typed https://github.com/facebook/flow/blob/v0.104.0/lib/dom.js#L3477
    script[key] = attributes[key]
  })

  // Listen for events
  Object.keys(events).forEach(key => {
    typeof events[key] === 'function'
      ? script.addEventListener(key, events[key])
      : script.addEventListener(key, events[key][0], events[key][1])
  })

  // $FlowFixMe - Flow is worried `body` might not exist
  document.body.appendChild(script)

  return script
}
